// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"6088bc5ebd075bc7446f","811":"e972fb5fd279af4d527c"}[chunkId] + ".js";
};